import React from "react";

const BbsCategoryTabs = ({ categories, selectedCategory, onSelectCategory }) => {
  return (
    <div className="flex flex-wrap gap-2">
      <button
        type="button"
        onClick={() => onSelectCategory("")}
        className={`chip ${selectedCategory ? "" : "chip-active"}`}
      >
        전체
      </button>
      {categories.map((category) => (
        <button
          key={category.id}
          type="button"
          onClick={() => onSelectCategory(category.name)}
          className={`chip ${selectedCategory === category.name ? "chip-active" : ""}`}
        >
          {category.name}
        </button>
      ))}
    </div>
  );
};

export default BbsCategoryTabs;
